import { render, staticRenderFns } from "./LibQuota.vue?vue&type=template&id=71d16a74&scoped=true"
import script from "./LibQuota.vue?vue&type=script&lang=js"
export * from "./LibQuota.vue?vue&type=script&lang=js"
import style0 from "./LibQuota.vue?vue&type=style&index=0&id=71d16a74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d16a74",
  null
  
)

export default component.exports